import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle,
  Stack,
  styled
} from '@mui/material';
import {
  appEvents,
  fields
} from 'modules';

import * as dataService from './dataService';



const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  minWidth: 420,
  paddingTop: theme.spacing(1),
  marginBottom: theme.spacing(3)
}));


const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();

export interface IProps {
  id?: string;
  campaignId?: string;

  onCardCreated?: () => void;
}

export const FC: React.FC<IProps> = props => {
  const { form, loading, mutations } = dataService.useEditInvestorCardModal(props.campaignId, props.id);



  async function processSubmit(data: dataService.IFormData) {
    await mutations.saveInvestorCard(data);
    handleClose();
  }



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <>
      <Dialog
        open
        onClose={handleClose}
        maxWidth="xs">
        <DialogTitle>{props.id ? 'Edit Card' : 'Create New Card'}</DialogTitle>

        <form onSubmit={form.handleSubmit(processSubmit)}>
          <DialogContent>
            <Stack spacing={3}>
              <ControlledTextField
                formControl={form.control}
                isDisabled={loading}
                label="Company Name"
                fieldKey="companyName" />

              <ControlledTextField
                type="number"
                isDisabled={loading}
                formControl={form.control}
                label="($) Potential Investment Amount (optional)"
                fieldKey="potentialInvestmentAmount" />
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              disabled={loading}>
              Cancel
            </Button>

            <Button
              type="submit"
              disabled={loading}>
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
